import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import { getStandApk } from '../services/commonService'
import '../css/style.css'
import '../css/reset.css'
import '../css/responsive.css'
import '../css/glightbox.css'

function StandApp() {
  const { t } = useTranslation();
  const [apk, setApk] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const loadApk = async () => {
      const { data } = await getStandApk();
      if (isMounted) {
        setApk(data?.model ?? null);
        setLoading(false);
      }
    };
    loadApk();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <Header />
      <section className="banners" style={{ backgroundImage: `url(${'../../images/banners_bg.webp'})` }}>
        <div className="container">
          <div className="banner_head">
            <h1>{t("standApp.title")}</h1>
          </div>
        </div>
      </section>
      <section style={{ padding: "60px 0", textAlign: "center" }}>
        <div className="container">
          {loading && <p>{t("standApp.loading")}</p>}
          {!loading && !apk && <p>{t("standApp.notAvailable")}</p>}
          {!loading && apk && (
            <>
              <p>{t("standApp.description")}</p>
              <div className="submit_btn">
                <input
                  type="button"
                  value={t("standApp.download")}
                  onClick={() => { window.location.href = apk.FilePath; }}
                />
              </div>
            </>
          )}
        </div>
      </section>
      <Footer />
    </>
  )
}

export default StandApp
